/**
 * Scroll-triggered load more for testimonial listing (design two).
 */
jQuery(function ($) {
	if (typeof window.localVars === 'undefined') {
		return;
	}

	const $listings = $('.js-testi-listing');
	if (!$listings.length) {
		return;
	}

	$listings.each(function () {
		const $root = $(this);
		const $sentinel = $root.find('.testi-listing__sentinel');
		const $status = $root.find('.testi-listing__status');
		if (!$sentinel.length) {
			return;
		}

		let ids;
		try {
			ids = JSON.parse($root.attr('data-testi-ids') || '[]');
		} catch (e) {
			return;
		}
		if (!Array.isArray(ids) || !ids.length) {
			return;
		}

		const perPage = parseInt($root.attr('data-per-page'), 10) || 4;
		let loading = false;
		let done = false;
		let observer = null;

		function removeSkeleton() {
			$root.find('.testi-listing__skeleton').remove();
		}

		function buildSkeletonMarkup(count) {
			const rows = [];
			for (let i = 0; i < count; i++) {
				rows.push(
					'<div class="testi-listing-skeleton-item d-flex align-items-center">' +
						'<div class="testi-listing-skeleton-item__image testi-listing-skeleton-shimmer"></div>' +
						'<div class="testi-listing-skeleton-item__content">' +
							'<div class="testi-listing-skeleton-item__stars testi-listing-skeleton-shimmer"></div>' +
							'<div class="testi-listing-skeleton-item__quote">' +
								'<span class="testi-listing-skeleton-line testi-listing-skeleton-shimmer"></span>' +
								'<span class="testi-listing-skeleton-line testi-listing-skeleton-line--short testi-listing-skeleton-shimmer"></span>' +
							'</div>' +
							'<div class="testi-listing-skeleton-item__meta">' +
								'<span class="testi-listing-skeleton-pill testi-listing-skeleton-shimmer"></span>' +
								'<span class="testi-listing-skeleton-pill testi-listing-skeleton-pill--wide testi-listing-skeleton-shimmer"></span>' +
							'</div>' +
						'</div>' +
					'</div>'
				);
			}
			return '<div class="testi-listing__skeleton" aria-hidden="true">' + rows.join('') + '</div>';
		}

		function showSkeleton() {
			removeSkeleton();
			$sentinel.before(buildSkeletonMarkup(perPage));
		}

		function finish() {
			done = true;
			removeSkeleton();
			if (observer && $sentinel.length) {
				observer.unobserve($sentinel[0]);
			}
			$sentinel.remove();
			$status.text('');
			$root.removeAttr('aria-busy');
		}

		function loadMore() {
			if (loading || done) {
				return;
			}
			loading = true;
			$root.attr('aria-busy', 'true');
			$status.text('Loading');
			showSkeleton();

			const offset = $root.find('.testi-listing-item').length;

			$.ajax({
				url: window.localVars.ajax_url,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'dma_testimonials_load_more',
					nonce: window.localVars.nonce,
					ids: JSON.stringify(ids),
					offset,
					per_page: perPage,
				},
			})
				.done(function (res) {
					removeSkeleton();
					if (!res || !res.success || !res.data) {
						$status.text('');
						$root.removeAttr('aria-busy');
						return;
					}
					const payload = res.data;
					if (payload.html) {
						$sentinel.before(payload.html);
					}
					if (!payload.has_more) {
						finish();
					} else {
						$status.text('');
						$root.removeAttr('aria-busy');
					}
				})
				.fail(function () {
					removeSkeleton();
					$status.text('');
					$root.removeAttr('aria-busy');
				})
				.always(function () {
					loading = false;
				});
		}

		if (!window.IntersectionObserver) {
			loadMore();
			return;
		}

		observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						loadMore();
					}
				});
			},
			{ root: null, rootMargin: '240px 0px', threshold: 0 }
		);

		observer.observe($sentinel[0]);
	});
});
